import { createRouter, createWebHistory } from 'vue-router'
import HomeIndex from '@/views/home/HomeIndex.vue'
import HomeCenter from '@/views/home/HomeCenter.vue'
import HomeHome from '@/views/home/HomeHome.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    children: [
      {
        path: '/',
        name: 'homeindex',
        component: HomeIndex,
        meta: {
          title: '青蛙计划'
        },
        children: [
          {
            path: '/',
            name: 'homecenter',
            component: HomeCenter,
            meta: {
              title: '青蛙计划'
            },
            children: [
              {
                path: '/',
                name: 'homehome',
                component: HomeHome,
                meta: {
                  title: '青蛙计划'
                }
              },
              {
                path: '/article',
                name: 'article',
                component: () => import('@/views/home/HomeArticle.vue'),
                meta: {
                  title: '文章'
                }
              },
              {
                path: '/write',
                name: 'write',
                component: () => import('@/views/home/HomeWrite.vue'),
                meta: {
                  title: '写作'
                }
              },
              {
                path: '/post/:id',
                name: 'post',
                component: () => import('@/views/home/HomeDesc.vue')
              }
            ]
          },
          {
            path: '/login',
            name: 'userlogin',
            component: () => import('@/views/home/login/UserLogin.vue'),
            meta: {
              title: '用户登录'
            }
          }
        ]
      },
      {
        path: '/pin',
        name: 'pinindex',
        component: () => import('@/views/pdd/PinIndex.vue'),
        meta: {
          title: 'pdd裁剪计算'
        }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || '吃掉那只青蛙'
  next()
})

export default router
